import {resolveBackground} from '#core/utils/color-utils.js';
import {merge} from '#core/utils/config-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateBorder} from '#core/application/modules/tiles/border/index.js';
import {generateToggleButton} from '#core/application/modules/tiles/button/index.js';

import VIEW_SWITCHER from './view-switcher.palette-schema.yaml';

registerTileSchema(VIEW_SWITCHER);

export function generateViewSwitcher(TILE) {
    return {
        switcherContainer: {
            itemSpacing: 4,
            style: {
                padding: 2,
                boxSizing: 'border-box',
                ...resolveBackground(TILE.VIEW_SWITCHER_SELECTOR.TOGGLE_BUTTON_BG),
                ...generateBorder(TILE.VIEW_SWITCHER_CONTAINER_BORDER),
            },
        },
        switcherButton: merge(generateToggleButton(TILE.VIEW_SWITCHER_SELECTOR, true), {
            unselected: {
                style: {
                    base: {
                        minHeight: '100%',
                        height: 'initial',
                        margin: 0,
                        borderColor: 'transparent',
                    },
                    hover: {
                        borderColor: 'transparent',
                        ...resolveBackground(TILE.VIEW_SWITCHER_SELECTOR.TOGGLE_BUTTON_BG),
                        ...TILE.VIEW_SWITCHER_SELECTOR.TOGGLE_BUTTON_TEXT,
                    },
                    active: {
                        borderColor: 'transparent',
                        ...resolveBackground(TILE.VIEW_SWITCHER_SELECTOR.TOGGLE_BUTTON_BG),
                        ...TILE.VIEW_SWITCHER_SELECTOR.TOGGLE_BUTTON_TEXT,
                    },
                },
            },
            selected: {
                style: {
                    base: {
                        minHeight: '100%',
                        height: 'initial',
                        margin: 0,
                        borderColor: 'transparent',
                        borderRadius: 4,
                    },
                    hover: {
                        borderColor: 'transparent',
                    },
                    active: {
                        borderColor: 'transparent',
                    },
                },
            },
        }),
    };
}
